export default "__VITE_ASSET__Cgi6J2V0__"